import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, onWheel, ...props }, ref) => {
    const handleWheel: React.WheelEventHandler<HTMLInputElement> = (e) => {
      onWheel?.(e)

      // Prevent mouse-wheel/trackpad from changing number inputs while scrolling.
      if (!e.defaultPrevented && type === "number") {
        e.preventDefault()
        e.currentTarget.blur()
      }
    }

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
        onWheel={type === "number" ? handleWheel : onWheel}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
